import { Box } from "@mui/material"
import { SimpleDekuStickItem } from "../inventory/items/DekuStickItem"
import { SimpleDekuNutItem } from "../inventory/items/DekuNutsItem"
import BombItem from "../inventory/items/BombItem"
import BowItem from "../inventory/items/BowItem"
import FireArrowItem from "../inventory/items/FireArrowItem"
import DinsFireItem from "../inventory/items/DinsFireItem"
import SlingshotItem from "../inventory/items/SlingshotItem"
import { SimpleOcarinaItem } from "../inventory/items/OcarinaItem"
import BombchusItem from "../inventory/items/BombchusItem"
import HookshotItem from "../inventory/items/HookshotItem"
import IceArrowItem from "../inventory/items/IceArrowItem"
import FaroresWindItem from "../inventory/items/FaroresWindItem"
import BoomrangItem from "../inventory/items/BoomrangItem"
import LensOfTruthItem from "../inventory/items/LensOfTruthItem"
import MagicBeansItem from "../inventory/items/MagicBeansItem"
import MegatonHammerItem from "../inventory/items/MegatonHammerItem"
import LightArrowItem from "../inventory/items/LightArrowItem"
import NayrusLoveItem from "../inventory/items/NayrusLoveItem"
import { CommonBigPoeBottleItem } from "../inventory/items/BigPoeBottleItem"
import { CommonEmptyBottleItem } from "../inventory/items/EmptyBottle"
import MagicItem from "../inventory/items/MagicItem"
import WalletItem from "../inventory/items/WalletItem"
import ScaleItem from "../inventory/items/ScaleItem"
import StrengthItem from "../inventory/items/StrengthItem"
import KokiriSwordItem from "../inventory/items/KokiriSwordItem"
import HylianShieldItem from "../inventory/items/HylianShieldItem"
import GoronTunicItem from "../inventory/items/GoronTunicItem"
import IronBootsItem from "../inventory/items/IronBootsItem"
import TokenItemCounter from "../inventory/items/TokenCounterItem"
import BiggoronSwordItem from "../inventory/items/BiggoronSwordItem"
import MirrorShieldItem from "../inventory/items/MirrorShieldItem"
import ZoraTunicItem from "../inventory/items/ZoraTunicItem"
import HoverBootsItem from "../inventory/items/HoverBootsItem"
import ZeldaLullabySong from "../inventory/songs/ZeldaLullabySong"
import EponaSong from "../inventory/songs/EponaSong"
import SariaSong from "../inventory/songs/SariaSong"
import SunSong from "../inventory/songs/SunSong"
import TimeSong from "../inventory/songs/TimeSong"
import StormSong from "../inventory/songs/StormSong"
import MinuetOfForest from "../inventory/songs/MinuetOfForest"
import BoleroOfFire from "../inventory/songs/BoleroOfFire"
import SerenadeOfWater from "../inventory/songs/SerenadeOfWater"
import NocturneOfShadow from "../inventory/songs/NocturneOfShadow"
import RequiemOfSpirit from "../inventory/songs/RequiemOfSpirit"
import PreludeOfLight from "../inventory/songs/PreludeOfLight"
import LightMedallionItem from "../inventory/medallions/LightMedallionItem"
import ForestMedallionItem from "../inventory/medallions/ForestMedallionItem"
import FireMedallionItem from "../inventory/medallions/FireMedallionItem"
import WaterMedallionItem from "../inventory/medallions/WaterMedallionItem"
import ShadowMedallionItem from "../inventory/medallions/ShadowMedallionItem"
import SpiritMedallionItem from "../inventory/medallions/SpiritMedallionItem"
import KokiriEmeraldItem from "../inventory/medallions/KokiriEmeraldItem"
import GoronRubyItem from "../inventory/medallions/GoronRubyItem"
import ZoraSapphireItem from "../inventory/medallions/ZoraSapphireItem"
import AlwaysHint from "../hints/AlwaysHints"
import Biggoron from "../../core/assets/oot/gshd/biggoron_32x32.png";
import Token40 from "../../core/assets/oot/gshd/40-gold-skulltula_32x32.png";
import Nocturne from "../../core/assets/oot/gshd/nocturne_32x32.png";
import OoT from "../../core/assets/oot/gshd/ocarina-of-time_32x32.png";
import Token50 from "../../core/assets/oot/gshd/50-gold-skulltula_32x32.png";
import Token30 from "../../core/assets/oot/gshd/30-gold-skulltula_32x32.png";
import Frog from "../../core/assets/oot/gshd/frogs_32x32.png";
import Frog2 from "../../core/assets/oot/song/frogsong.png";
import SkullMask from "../../core/assets/oot/gshd/skull-mask_32x32.png";
import { dungeons } from "../dungeon/DungeonSelector"
import { DungeonKeysTrackingHorizontal } from "../keysanity/DungeonsKeysTracking"
import { DungeonsKeysList } from "../keysanity/DungeonsKeysData"
import { isEmpty } from "lodash"
import { BarrenHint } from "../mixpool/ReworkwothHint"
import SometimeHint from "../hints/SometimesHint"
import PathHint from "../hints/PathHint"
import LightSphereTracker from "../sphere/LigthSphereTracker"
import AdultSequenceItem from "../inventory/items/AdultSequenceItem"
import OotItemContextMenuButton from "../hints/OotItemContextMenuButton"
import RutoLetterItem from "../inventory/items/RutoLetterBottle"

const MainTournamentTracker = () => {

    return <Box>
        <Box position={"absolute"} top={100} left={80}>
            <SimpleDekuStickItem />
        </Box>
        <Box position={"absolute"} top={100} left={112}>
            <SimpleDekuNutItem />
        </Box>
        <Box position={"absolute"} top={100} left={144}>
            <BombItem />
        </Box>
        <Box position={"absolute"} top={100} left={176}>
            <BowItem />
        </Box>
        <Box position={"absolute"} top={100} left={208}>
            <FireArrowItem />
        </Box>
        <Box position={"absolute"} top={100} left={240}>
            <DinsFireItem />
        </Box>

        {/* Line 2 */}
        <Box position={"absolute"} top={132} left={80}>
            <SlingshotItem />
        </Box>
        <Box position={"absolute"} top={132} left={112}>
            <SimpleOcarinaItem />
        </Box>
        <Box position={"absolute"} top={132} left={144}>
            <BombchusItem />
        </Box>
        <Box position={"absolute"} top={132} left={176}>
            <HookshotItem />
        </Box>
        <Box position={"absolute"} top={132} left={208}>
            <IceArrowItem />
        </Box>
        <Box position={"absolute"} top={132} left={240}>
            <FaroresWindItem />
        </Box>

        {/* Line 3 */}
        <Box position={"absolute"} top={164} left={80}>
            <BoomrangItem />
        </Box>
        <Box position={"absolute"} top={164} left={112}>
            <LensOfTruthItem />
        </Box>
        <Box position={"absolute"} top={164} left={144}>
            <MagicBeansItem />
        </Box>
        <Box position={"absolute"} top={164} left={176}>
            <MegatonHammerItem />
        </Box>
        <Box position={"absolute"} top={164} left={208}>
            <LightArrowItem />
        </Box>
        <Box position={"absolute"} top={164} left={240}>
            <NayrusLoveItem />
        </Box>

        {/* Line 4 */}
        <Box position={"absolute"} top={198} left={80}>
            <CommonBigPoeBottleItem />
        </Box>
        <Box position={"absolute"} top={198} left={112}>
            <CommonEmptyBottleItem />
        </Box>
        <Box position={"absolute"} top={198} left={144}>
            <MagicItem />
        </Box>
        <Box position={"absolute"} top={198} left={176}>
            <WalletItem />
        </Box>
        <Box position={"absolute"} top={198} left={208}>
            <ScaleItem />
        </Box>
        <Box position={"absolute"} top={198} left={240}>
            <StrengthItem />
        </Box>

        {/* Equipements */}
        {/* Line 1 */}
        <Box position={"absolute"} top={230} left={80}>
            <KokiriSwordItem />
        </Box>
        <Box position={"absolute"} top={230} left={112}>
            <HylianShieldItem />
        </Box>
        <Box position={"absolute"} top={230} left={144}>
            <GoronTunicItem />
        </Box>
        <Box position={"absolute"} top={230} left={176}>
            <IronBootsItem />
        </Box>
        <Box position={"absolute"} top={230} left={208}>
            <AdultSequenceItem type="last" />
        </Box>
        <Box position={"absolute"} top={230} left={240}>
            <RutoLetterItem />
        </Box>
        <Box position={"absolute"} top={260} left={225}>
            <TokenItemCounter />
        </Box>

        {/* Line 2 */}
        <Box position={"absolute"} top={262} left={80}>
            <BiggoronSwordItem />
        </Box>
        <Box position={"absolute"} top={262} left={112}>
            <MirrorShieldItem />
        </Box>
        <Box position={"absolute"} top={262} left={144}>
            <ZoraTunicItem />
        </Box>
        <Box position={"absolute"} top={262} left={176}>
            <HoverBootsItem />
        </Box>

        {/* Songs */}
        {/* Line 1 */}
        <Box position={"absolute"} top={300} left={80}>
            <ZeldaLullabySong cleft cright cup display="horizontal" />
        </Box>
        <Box position={"absolute"} top={300} left={112}>
            <EponaSong cleft cright cup display="horizontal" />
        </Box>
        <Box position={"absolute"} top={300} left={144}>
            <SariaSong cleft cright cdown display="horizontal" />
        </Box>
        <Box position={"absolute"} top={300} left={176}>
            <SunSong cdown cright cup display="horizontal" />
        </Box>
        <Box position={"absolute"} top={300} left={208}>
            <TimeSong a cdown cright display="horizontal" />
        </Box>
        <Box position={"absolute"} top={300} left={240}>
            <StormSong a cdown cup display="horizontal" />
        </Box>

        {/* Line 2 */}
        <Box position={"absolute"} top={345} left={80}>
            <MinuetOfForest a cleft cright cup display="horizontal" />
        </Box>
        <Box position={"absolute"} top={345} left={112}>
            <BoleroOfFire a cright cdown display="horizontal" />
        </Box>
        <Box position={"absolute"} top={345} left={144}>
            <SerenadeOfWater a cleft cright cdown display="horizontal" />
        </Box>
        <Box position={"absolute"} top={345} left={176}>
            <NocturneOfShadow cdown cright cleft a display="horizontal" />
        </Box>
        <Box position={"absolute"} top={345} left={208}>
            <RequiemOfSpirit a cdown cright display="horizontal" />
        </Box>
        <Box position={"absolute"} top={345} left={240}>
            <PreludeOfLight cleft cright cup display="horizontal" />
        </Box>



        {/* Medallion and Stone */}
        <Box position={"absolute"} top={100} left={272}>
            <LightMedallionItem />
        </Box>
        <Box position={"absolute"} top={100} left={315}>
            <ForestMedallionItem />
        </Box>
        <Box position={"absolute"} top={100} left={360}>
            <FireMedallionItem />
        </Box>
        <Box position={"absolute"} top={150} left={272}>
            <WaterMedallionItem />
        </Box>
        <Box position={"absolute"} top={150} left={315}>
            <ShadowMedallionItem />
        </Box>
        <Box position={"absolute"} top={150} left={360}>
            <SpiritMedallionItem />
        </Box>
        <Box position={"absolute"} top={200} left={272}>
            <KokiriEmeraldItem />
        </Box>
        <Box position={"absolute"} top={200} left={315}>
            <GoronRubyItem />
        </Box>
        <Box position={"absolute"} top={200} left={360}>
            <ZoraSapphireItem />
        </Box>

        {/* Always */}
        <Box position={"absolute"} top={250} left={272}>
            <AlwaysHint hint={{ name: "Burning Kak", img: Nocturne }} />
        </Box>
        <Box position={"absolute"} top={250} left={340}>
            <AlwaysHint
                hint={{ name: "OoT", img: OoT }}
            />
        </Box>
        <Box position={"absolute"} top={282} left={272}>
            <AlwaysHint hint={{ name: "ZR Frogs Ocarina Game", img: Frog }} />
        </Box>
        <Box position={"absolute"} top={282} left={340}>
            <AlwaysHint
                hint={{ name: "LW Deku Theater Skull Mask", img: SkullMask }}
            />
        </Box>
        <Box position={"absolute"} top={314} left={272}>
            <AlwaysHint
                hint={{ name: "Biggoron", img: Biggoron }}
            />
        </Box>
        <Box position={"absolute"} top={314} left={340}>
            <AlwaysHint
                hint={{ name: "Kak 30 Gold Skulltula Reward", img: Token30 }}
            />
        </Box>
        <Box position={"absolute"} top={346} left={272}>
            <AlwaysHint
                hint={{ name: "Kak 40 Gold Skulltula Reward", img: Token40 }}
            />
        </Box>
        <Box position={"absolute"} top={346} left={340}>
            <AlwaysHint
                hint={{ name: "Kak 50 Gold Skulltula Reward", img: Token50 }}
            />
        </Box>

        <Box position={"absolute"}  top={390} left={80}>
            <img src={Frog2} alt="Frog 2" width={"320px"} />
        </Box>

        <Box display={"flex"} position={"absolute"} top={100} left={410} flexDirection={"column"}>
            {Array.from(Array(6).keys()).map(t => {
                return <SometimeHint />
            })}
            <SometimeHint type="dual" />
            <SometimeHint type="dual" />
        </Box>

        <Box display={"flex"} position={"absolute"} top={415} left={480}>
            <Box display={"flex"} flexDirection={"column"} width={"300px"}>
            <Box display={"flex"} textAlign={"center"} width={"100%"} justifyContent={"center"}>Peek</Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}><Box  width={"300px"}>Graveyard Freestanding </Box><Box display={"flex"} flexDirection={"row"} width={"100%"}><OotItemContextMenuButton /></Box></Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}><Box  width={"300px"}>Desert colossus Arch </Box><Box display={"flex"} flexDirection={"row"} width={"100%"}><OotItemContextMenuButton /></Box></Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}><Box  width={"300px"}>DMC freestanding </Box><Box display={"flex"} flexDirection={"row"} width={"100%"}><OotItemContextMenuButton /></Box></Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}><Box  width={"300px"}>Lake RL</Box><Box display={"flex"} flexDirection={"row"} width={"100%"}><OotItemContextMenuButton /></Box></Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}><Box  width={"300px"}>Fortress Roof Chest </Box><Box display={"flex"} flexDirection={"row"} width={"100%"}> <OotItemContextMenuButton /></Box></Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}><Box  width={"300px"}>Botw ZL Chests  </Box><Box display={"flex"} flexDirection={"row"} width={"100%"}><OotItemContextMenuButton />  <OotItemContextMenuButton /></Box></Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}><Box  width={"300px"}>BotW Bomb Chests </Box><Box display={"flex"} flexDirection={"row"} width={"100%"}><OotItemContextMenuButton />  <OotItemContextMenuButton />  <OotItemContextMenuButton /></Box></Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}><Box  width={"300px"}>Goron City maze </Box><Box display={"flex"} flexDirection={"row"} width={"100%"}> <OotItemContextMenuButton />  <OotItemContextMenuButton />  <OotItemContextMenuButton /></Box></Box>
        </Box>
        </Box>



        {/* DUNGEONS */}
        <Box display={"flex"} position={"absolute"} top={100} left={630} flexDirection={"column"} width={400}>
            
            {dungeons.map(d => {
                if (isEmpty(d) || DungeonsKeysList.filter(x => x.dungeon === d).length === 0)
                    return null;
                return <Box display={"flex"} flexDirection={"row"}>
                    <Box width={50} display="flex" alignItems={"center"}>{d}</Box>
                    <Box width={100}><DungeonKeysTrackingHorizontal dungeon={DungeonsKeysList.filter(x => x.dungeon === d)?.[0]} id={d} />   </Box>
                </Box>
            })}
        </Box>

        <Box display={"flex"} position={"absolute"} top={100} left={780} flexDirection={"column"} >
            {/* <EntranceTracker overworld={false} dungeons={state.erDungeon && state.mixPoolDungeon && state.mixPool} grottos={state.mixPool} interrior={state.mixPool} /> */}
            <LightSphereTracker />
        </Box>
        <Box
            position={"absolute"}
            top={455}
            left={80}
            display={"flex"}
            alignItems={"center"}
        >
            {" "}
            <PathHint id={0} />
        </Box>
        <Box
            position={"absolute"}
            top={490}
            left={80}
            display={"flex"}
            alignItems={"center"}
        >
            {" "}
            <PathHint id={1} />
        </Box>
        <Box
            position={"absolute"}
            top={525}
            left={80}
            display={"flex"}
            alignItems={"center"}
        >
            {" "}
            <PathHint id={2} />
        </Box>
        <Box
            position={"absolute"}
            top={560}
            left={80}
            display={"flex"}
            alignItems={"center"}
        >
            {" "}
            <PathHint id={3} />
        </Box>
        <Box
            position={"absolute"}
            top={600}
            left={80}
            display={"flex"}
            alignItems={"center"}
        >
            {" "}
            <PathHint id={4} />
        </Box>

        {/* 3 Barrens  */}
        <Box
            position={"absolute"}
            top={640}
            left={80}
            display={"flex"}
            alignItems={"center"}
        >
            {" "}
            <BarrenHint />
        </Box>
        <Box
            position={"absolute"}
            top={675}
            left={80}
            display={"flex"}
            alignItems={"center"}
        >
            {" "}
            <BarrenHint />
        </Box>
        <Box
            position={"absolute"}
            top={710}
            left={80}
            display={"flex"}
            alignItems={"center"}
        >
            {" "}
            <BarrenHint />
        </Box>
    </Box>
}

export default MainTournamentTracker